import { render, staticRenderFns } from "./LinkedIdsForm.vue?vue&type=template&id=001ebd9c&scoped=true&"
import script from "./LinkedIdsForm.vue?vue&type=script&lang=js&"
export * from "./LinkedIdsForm.vue?vue&type=script&lang=js&"
import style0 from "./LinkedIdsForm.vue?vue&type=style&index=0&id=001ebd9c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001ebd9c",
  null
  
)

export default component.exports